import { Gondor } from "../Gondor";

const ACTIONS = {
  LENDER: "/lender/",
  LENDER_ITEM: "/lender/{id}/",
  ADD_SYSTEMS: "/lender/add/system",
  REMOVE_SYSTEMS: "/lender/remove/system",
};

export function find(params?: object) {
  return Gondor.API.get(ACTIONS.LENDER, { params });
}

export function findOne(id: number | string) {
  id = id.toString();
  return Gondor.API.get(ACTIONS.LENDER_ITEM.replace("{id}", id));
}

export function create(body: object) {
  return Gondor.API.post(ACTIONS.LENDER, body);
}

export function update(id: number | string, body: object) {
  id = id.toString();
  return Gondor.API.patch(ACTIONS.LENDER_ITEM.replace("{id}", id), body);
}

export function destroy(id: number | string) {
  id = id.toString();
  return Gondor.API.delete(ACTIONS.LENDER_ITEM.replace("{id}", id));
}

export function addSystems(body: object) {
  return Gondor.API.post(ACTIONS.ADD_SYSTEMS, body);
}

export function removeSystems(body: object) {
  return Gondor.API.post(ACTIONS.REMOVE_SYSTEMS, body);
}
